import React from 'react';
import { StyledStarTitle, StyledStarTitleWrapper } from './StarTitle.style';

function StarTitle({ text }) {
  return (
      <StyledStarTitleWrapper>
        <StyledStarTitle text={text}>
          {text}
        </StyledStarTitle>
      </StyledStarTitleWrapper>
  );
}

export default StarTitle;
